/**
 * 此处可直接引用自己项目封装好的 axios 配合后端联调
 */


import request from "./../utils/axios"  //组件内部封装的axios
// import http from "@/api/index"       //调用项目封装的axios
let lang = localStorage.getItem('2d3d-language')
//获取验证图片  以及token
export function reqGet(data) {
	return  request({
        url: '/v3/ActionCaptcha/getBehavior?lang='+lang,
        method: 'post',
        data
    })
}

//滑动或者点选验证
export function reqCheck(data) {
	return  request({
        url: '/v3/ActionRegister/sendPhoneCode?lang='+lang,
        method: 'post',
        data
    })
}

//滑动或者点选验证邮箱发送验证码
export function reqCheckEmail(data) {
	return  request({
        url: '/v3/ActionRegister/sendEmailCode?lang='+lang,
        method: 'post',
        data
    })
}


